import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "About", id: "about" },
  { label: "Programs", id: "programs" },
  { label: "In-Person", id: "in-person" },
  { label: "Results", id: "gallery" },
  { label: "FAQ", id: "faq" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 backdrop-blur-xl border-b transition-colors duration-300 ${
        scrolled ? "bg-[#0A0A0A]/90 border-[#262626]" : "bg-[#0A0A0A]/40 border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <button
          data-testid="nav-logo"
          onClick={() => scrollTo("hero")}
          className="text-left leading-none"
        >
          <span className="font-display font-bold text-lg sm:text-xl tracking-tight text-white block">
            HOWELL
          </span>
          <span className="text-[10px] uppercase tracking-[0.3em] text-[#0055FF] font-bold">
            Transformations
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="text-sm font-semibold text-[#A3A3A3] hover:text-white transition-colors uppercase tracking-wide"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-apply-button"
            onClick={() => scrollTo("apply")}
            className="bg-[#0055FF] text-white hover:bg-[#3377FF] transition-colors font-bold px-6 py-3 uppercase tracking-wide text-sm"
          >
            Apply Now
          </button>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden bg-[#0A0A0A] border-t border-[#262626] px-6 py-6 flex flex-col gap-4">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-mobile-link-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="text-left text-base font-semibold text-[#A3A3A3] hover:text-white uppercase tracking-wide"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-mobile-apply-button"
            onClick={() => scrollTo("apply")}
            className="bg-[#0055FF] text-white font-bold px-6 py-3 uppercase tracking-wide text-sm mt-2"
          >
            Apply Now
          </button>
        </div>
      )}
    </header>
  );
};
